import React from 'react';
import { ExternalLink, Lock } from 'lucide-react';

// Herkomst van een geïmporteerde motor — alleen in admin-schermen gebruiken.
export const SourceInfo = ({ source, motorcycleId }) => {
  if (!source) return null;
  return (
    <div className="text-xs bg-purple-50 border border-purple-200 rounded-md p-2 mb-3 text-purple-900" data-testid={`source-info-${motorcycleId}`}>
      <div className="flex items-center gap-1 font-semibold">
        <Lock className="w-3 h-3" /> Herkomst (alleen admin): MotoScout24
      </div>
      {source.seller && <div className="mt-0.5" data-testid={`source-seller-${motorcycleId}`}>Verkoper: {source.seller}</div>}
      {source.source_price_chf != null && (
        <div>Inkoop CHF {Number(source.source_price_chf).toLocaleString('de-CH')} + opslag CHF {Number(source.markup_chf || 0).toLocaleString('de-CH')}</div>
      )}
      {source.source_url && (
        <a href={source.source_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline mt-0.5"
           data-testid={`source-link-${motorcycleId}`}>
          Advertentie openen <ExternalLink className="w-3 h-3" />
        </a>
      )}
    </div>
  );
};
